<template>
  <div fill-height style="height: 100%">
    <v-layout style="height: 100%" justify-center>
      <v-flex xs12 sm10 md8 style="margin-top: 2rem">
        <v-card>
          <v-card-title>
            <v-layout row wrap>
              <v-flex xs12>
                <h1 class="text-xs-center">出勤打刻</h1>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-form id="login-form">
              <v-text-field type="number" label="社員番号" v-model="staffId" />
              {{ errorMessage }}
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout align-center justify-center row fill-height>
              <v-btn
                large
                color="deep-orange"
                class="white--text"
                @click="saveTime('start')"
                :disabled="isProcessing"
                >出勤</v-btn
              >
              <v-btn
                large
                color="indigo"
                class="white--text"
                @click="saveTime('end')"
                :disabled="isProcessing"
                >退勤</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="80%">
      <v-alert v-model="alert" :color="alertType">
        <h1>{{ helloUser }}</h1>
        <h1>{{ message }}</h1>
        <v-layout align-center justify-center row fill-height>
          <v-btn color="blue-grey" class="white--text" @click="dialog = false"
            >OK</v-btn
          >
        </v-layout>
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import { mapActions, mapState } from "vuex";
import { getMoment, unixtimeToFormattedTime } from "@/utils/datetime.js";
import { startWork, endWork } from "@/utils/startAndEndWork.js";

// var moment = require("moment-timezone");
// moment.tz.setDefault("Asia/Tokyo");
const keysOfOwnerToCopyToTimecard = {
  owner_id: "id",
  owner_name: "name",
  owner_team: "team_name",
  owner_user_type: "user_type",
  owner_work_type: "work_type",
};

export default {
  data() {
    return {
      owner: null,
      staffId: "",
      staffs: [],
      month: 1,
      date: 1,
      year: 2020,
      dateObjdect: {},
      dialog: false,
      alert: true,
      alertType: "success",
      message: "",
      helloUser: "",
      isProcessing: false,
    };
  },
  created: function () {},
  mounted() {
    this.reloadStaffs();
    this.setToday();
  },
  methods: {
    async setToday() {
      const today = getMoment()();
      this.month = today.month() + 1;
      this.year = today.year();
      this.date = today.date();
      await this.getCalendar();
    },
    async reloadStaffs() {
      this.changeLoadingState(true);
      this.staffs = [];
      try {
        const staffs = await db.collection("users").get();
        staffs.forEach((doc) => {
          this.staffs.push({ ...doc.data(), id: doc.id });
        });
      } finally {
        this.changeLoadingState(false);
      }
    },
    async getCalendar() {
      try {
        const item = await db
          .collection("calendar")
          .doc(this.month_id)
          .collection("dates")
          .doc(this.date_id)
          .get();
        this.dateObject = item.data();
      } catch (e) {
        console.error(e);
      }
    },

    async saveTime(type) {
      this.changeLoadingState(true);
      if (this.isProcessing == true) {
        return -1;
      } else {
        this.isProcessing = true;
      }
      this.helloUser = "";
      this.message = "";
      this.owner = null;
      const staffId = this.staffId.trim();
      const filterdStaffs = this.staffs.filter(
        (staff) => staff.staff_id == staffId
      );
      if (filterdStaffs.length == 1) {
        this.owner = filterdStaffs[0];
      } else {
        this.helloUser = "";
        this.message = "社員番号をご確認ください。";
        this.alertType = "error";
        this.dialog = true;
        this.isProcessing = false;
        this.changeLoadingState(false);
        return -1;
      }
      await this.setToday();
      const timesheetDocs = await db
        .collection("timesheets")
        .where("user_id", "==", this.owner.id)
        .where("month_id", "==", this.month_id)
        .orderBy("updatedAt", "desc")
        .get();

      if (!timesheetDocs.empty) {
        const sheet = timesheetDocs.docs[0].data();
        if (!sheet.owenr) this.owner = sheet.owner;
      }
      this.helloUser = this.owner.name + "さん、"
      let res = {};
      if (type == "start") {
        res = await startWork(this.owner, this.dateObject, "出社");
        this.helloUser += "おはようございます。"
      } else if (type == "end") {
        res = await endWork(this.owner, this.dateObject);
        this.helloUser += "お疲れ様でした。後日、原価を入力してください。"
      }
      
      if (res.status == "ok") {
        if(type == "start"){
        this.message =
          unixtimeToFormattedTime(res.data.start) + "に打刻しました。";
        }else if(type == "end"){
          this.message =
          unixtimeToFormattedTime(res.data.end) + "に打刻しました。";
        }
        this.alertType = "success";
        this.dialog = true;
        this.staffId = "";
      } else if (res.status == "error") {
        this.message = "エラーが発生しました。もう一度、打刻してください。";
        this.alertType = "warning";
        this.dialog = true;
        this.staffId = "";
      }
      this.isProcessing = false;
      this.changeLoadingState(false);
    },
    ...mapActions("auth", ["logIn"]),
    ...mapActions("app", ["changeLoadingState"]),
  },
  computed: {
    selectedStaff() {
      const staffId = this.staffId.trim();
      if (staffId.length < 3) {
        return this.staffs;
      } else {
        return this.staffs.filter((staff) => staff.staff_id == staffId);
      }
    },
    hasOnlyOneOwner() {
      return this.selectedStaff.length == 1;
    },
    month_id() {
      return String(this.year) + "-" + ("0" + this.month).slice(-2);
    },
    date_id() {
      return (
        String(this.year) +
        "-" +
        ("0" + this.month).slice(-2) +
        "-" +
        ("0" + this.date).slice(-2)
      );
    },
    ...mapState("auth", ["errorMessage"]),
  },
};
</script>
<style lang="css" scoped>
div.logo {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
}
</style>

